/*
  This configration for dev & prod and other stages.

*/
export const clientConfig = {
  development: {
    /* LP & Multisite Dev assets URLs */
    // lpAssectURL: '//10.102.21.15:3000/assetso',

    // lpAssectURL: '//assetsmrq.liverpool.com.mx/assetso',

    /* lpAssectURL: '//assetsmri.liverpool.com.mx/assetso' , */

    lpAssectURL: '/assets',
    pbAssectURL: '/assets',
    wsAssectURL: '/assets',
    pbkAssectURL: '/assets',
    gapAssectURL: '/assets',
    weAssectURL: '/assets',
    truAssectURL: '/assets',

    /* LP & Multisite Commerce redirect URLs */
    lpWEBURL: '//dtaqa.liverpool.com.mx',
    pbWEBURL: '//dtaqa.potterybarn.com.mx',
    wsWEBURL: '//dtaqa.williams-sonoma.com.mx',
    gapWEBURL: '//dtaqa.gap.com.mx',
    pbkWEBURL: '//dtaqa.potterybarnkids.com.mx',
    weWEBURL: '//dtaqa.westelm.com.mx',

    /* LP & Multisite GR URLs */
    lpGRURL: '//mesa.liverpool.com.mx:3000',
    wsGRURL: '//mesa.williams-sonoma.com.mx:3000',
    pbGRURL: '//mesa.potterybarn.com.mx:3000',
    pbkGRURL: '//www.mesapotterybarnkids.com.mx:3000',
    gapGRURL: '//www.mesagap.com.mx:3000',
    wlmGRURL: '//www.mesawestelm.com.mx:3000',
    truGRURL: '//mesaderegalosdtaqa.toysrus.com.mx',

    lpEventWebSiteURL: '//uat-api.mesaderegalos.liverpool.mx/liverpool/auth',

    lpURLPriFix: '/tienda',
    KalturaAPIURL: 'https://www.kaltura.com/api_v3',
    KalturaPartnerID: '2374251',
    KalturaSecretKey: '2ccc6cbf495a16639365cd6edda99b33', // '9b3be578a11222f7b50d184900524e7d',
    KalturaUser: 'fapalaciosp@liverpool.com.mx', // 'fapalaciosp@liverpool.com.mx', // 'sdolla@zensar.com',

    /* YAHOO START */
    yahooUserURL: '/v1/user/',
    YahooAuthAPIURL: 'https://api.login.yahoo.com',
    YahooSocialAPI: 'https://social.yahooapis.com',

    YahooClientId:
      'dj0yJmk9UnYyaUNOTk5JUEttJmQ9WVdrOVlsQmpVMnhMTlRZbWNHbzlNQS0tJnM9Y29uc3VtZXJzZWNyZXQmeD1lOA--',
    YahooClientSecret: 'f12f82b159acad3dc56586b8f0b9a5cf3054594f',
    YahooRedirectURI: 'http://grdev.liverpool.com.mx/auth/yahoo/callback',

    YahooClientIdPB:
      'dj0yJmk9TUd1OVlvRldOeHNwJmQ9WVdrOVlUSlhjWFZrTjJVbWNHbzlNQS0tJnM9Y29uc3VtZXJzZWNyZXQmeD0yZQ--',
    YahooClientSecretPB: 'a724b03de6879f0ac705643a69a1fd121798db5f',
    YahooRedirectURIPB: 'http://grdev.potterybarn.com.mx/auth/yahoo/callback',

    YahooClientIdGAP:
      'dj0yJmk9NHFva2pMSVBEcWVFJmQ9WVdrOWVHbExXSHA2TnpRbWNHbzlNQS0tJnM9Y29uc3VtZXJzZWNyZXQmeD04Yg--',
    YahooClientSecretGAP: '944be7cb7dfcf46196e922f48c59dc20341a186c',
    YahooRedirectURIGAP: 'http://grdev.gap.com.mx/auth/yahoo/callback',

    YahooClientIdWLM:
      'dj0yJmk9dVBNTDlZaUtxa2FrJmQ9WVdrOVdXcGpObWx3Tm5VbWNHbzlNQS0tJnM9Y29uc3VtZXJzZWNyZXQmeD0wNg--',
    YahooClientSecretWLM: '7e5502c33fc39489948bb2b47b38a442f3bf1638',
    YahooRedirectURIWLM: 'http://grdev.westelm.com.mx/auth/yahoo/callback',

    YahooClientIdWS:
      'dj0yJmk9WjNoTGRRNkZEajVuJmQ9WVdrOWFUbGFaVnBrTTJVbWNHbzlNQS0tJnM9Y29uc3VtZXJzZWNyZXQmeD00Yw--',
    YahooClientSecretWS: '2de91d54f361e88935daaef244300571d295ce44',
    YahooRedirectURIWS:
      'http://grdev.williams-sonoma.com.mx/auth/yahoo/callback',

    YahooClientIdPBK:
      'dj0yJmk9dFlKeFRtMjVKaU1PJmQ9WVdrOVoyOVVNWEV6TnpnbWNHbzlNQS0tJnM9Y29uc3VtZXJzZWNyZXQmeD03ZQ--',
    YahooClientSecretPBK: '73d0e9e66ae182868687f23ccfbe50325f08d625',
    YahooRedirectURIPBK:
      'http://grdev.potterybarnkids.com.mx/auth/yahoo/callback',

    YahooClientIdTRU: '',
    YahooClientSecretTRU: '',
    YahooRedirectURITRU: '',
    /* YAHOO END */

    gmailClientKey:
      '720751145813-m9hudr65fpkvibpo5ugpo9d9gp841rro.apps.googleusercontent.com',
    // creatr with LPmx Liverpoolproject
    // https://console.developers.google.com/apis/credentials/key/239?project=liverpoolproject-1520660438685
    // https://console.developers.google.com/apis/library?project=liverpoolproject-1520660438685
    gmailApikey: 'AIzaSyBg7HQhYNDj3A4ZkbqYqo9ffxLMFteBcyE',

    /* Google Map API Keys */
    googleMapApiKeyLP: 'AIzaSyAfZ6yVQdG4ePMI8N-xW1vkh3KTwaZ5SRk',
    googleMapApiKeyPB: 'AIzaSyCGqNf-wWAjOx9nQm7DZ2nR_kltiphDIZ4',
    googleMapApiKeyWS: 'AIzaSyCGqNf-wWAjOx9nQm7DZ2nR_kltiphDIZ4',
    googleMapApiKeyWLM: 'AIzaSyCGqNf-wWAjOx9nQm7DZ2nR_kltiphDIZ4',
    googleMapApiKeyGAP: 'AIzaSyCGqNf-wWAjOx9nQm7DZ2nR_kltiphDIZ4',
    googleMapApiKeyPBK: 'AIzaSyCGqNf-wWAjOx9nQm7DZ2nR_kltiphDIZ4',
    googleMapApiKeyTRU: 'AIzaSyCGqNf-wWAjOx9nQm7DZ2nR_kltiphDIZ4',

    isLocalAsset: true,
    excelTemplate: '/web/guestList/GR_guest_list-template.xls ',

    lpGROulookId: '1f2070c5-ef0d-4fee-97d3-34f4910255ae',
    pbGROulookId: '358d4765-8758-4839-940a-e23bedbfae78',
    wsGROulookId: 'd646f862-f035-4ebc-98c0-3eaf24bf18c4',
    gapGROulookId: '2ee487a8-bb6e-4a69-bd31-763c95d33efb',
    pbkGROulookId: '18aee1b7-e47b-44eb-add3-2a861e399fc5',
    wlmROulookId: '257cdf7b-1d6b-4e2a-99e9-6ec51425f94a',
    truGROulookId: '',

    lpGROulookRedirectUri: 'https://mesaderegalosqa.liverpool.com.mx/outlook',
    wsGROulookRedirectUri:
      'https://mesaderegalosqa.williams-sonoma.com.mx/outlook',
    pbGROulookRedirectUri: 'https://mesaderegalosqa.potterybarn.com.mx/outlook',
    pbkGROulookRedirectUri:
      'https://mesaderegalosqa.potterybarnkids.com.mx/outlook',
    gapGROulookRedirectUri: 'https://mesaderegalosqa.gap.com.mx/outlook',
    wlmGROulookRedirectUriL: 'https://mesaderegalosqa.westelm.com.mx/outlook',
    truGROulookRedirectUri: 'https://mesaderegalosqa.toysrus.com.mx/outlook',

    lpfacebookAppId: '2338494446209650', // liverpool.demoapis@gmail.com
    wsfacebookAppId: '2338494446209650',
    pbfacebookAppId: '2338494446209650',
    pbkfacebookAppId: '2338494446209650',
    gapfacebookAppId: '2338494446209650',
    wlmfacebookAppId: '2338494446209650',
    trufacebookAppId: '2338494446209650',

    lpTagging: {
      GTMID: 'GTM-WJPZC4D',
      Auth: 'vkVXZCRD6B5eLz3C40W_yQ',
      previewID: 'env-30',
    },

    wsTagging: {
      GTMID: 'GTM-WJPZC4D',
      Auth: 'vkVXZCRD6B5eLz3C40W_yQ',
      previewID: 'env-30',
    },
    pbTagging: {
      GTMID: 'GTM-WJPZC4D',
      Auth: 'vkVXZCRD6B5eLz3C40W_yQ',
      previewID: 'env-30',
    },
    pbkTagging: {
      GTMID: 'GTM-WJPZC4D',
      Auth: 'vkVXZCRD6B5eLz3C40W_yQ',
      previewID: 'env-30',
    },
    gapTagging: {
      GTMID: 'GTM-WJPZC4D',
      Auth: 'vkVXZCRD6B5eLz3C40W_yQ',
      previewID: 'env-30',
    },
    wlmTagging: {
      GTMID: 'GTM-WJPZC4D',
      Auth: 'vkVXZCRD6B5eLz3C40W_yQ',
      previewID: 'env-30',
    },
    truTagging: {
      GTMID: '',
      Auth: '',
      previewID: '',
    },
  },
  production: {
    /* LP & Multisite Production assets URLs  Not to be change */
    lpAssectURL: 'https://assetsmesaderegalos.liverpool.com.mx/assets',
    pbAssectURL: 'https://assetsmesaderegalos.liverpool.com.mx/assets',
    wsAssectURL: 'https://assetsmesaderegalos.liverpool.com.mx/assets',
    pbkAssectURL: 'https://assetsmesaderegalos.liverpool.com.mx/assets',
    gapAssectURL: 'https://assetsmesaderegalos.liverpool.com.mx/assets',
    weAssectURL: 'https://assetsmesaderegalos.liverpool.com.mx/assets',
    truAssectURL: 'https://assetsmesaderegalos.liverpool.com.mx/assets',

    /* LP & Multisite UAT redirect URLs need to comment for Prod */
    // lpWEBURL: '//wqa.liverpool.com.mx',
    // pbWEBURL: '//wqa.potterybarn.com.mx',
    // wsWEBURL: '//wqa.williams-sonoma.com.mx',
    // gapWEBURL: '//wqa.gap.com.mx',
    // pbkWEBURL: '//wqa.potterybarnkids.com.mx',
    // weWEBURL: '//wqa.westelm.com.mx',

    // // // // Prod LP & MS URLs
    lpWEBURL: '//www.liverpool.com.mx',
    pbWEBURL: '//www.potterybarn.com.mx',
    wsWEBURL: '//www.williams-sonoma.com.mx',
    gapWEBURL: '//www.gap.com.mx',
    pbkWEBURL: '//www.potterybarnkids.com.mx',
    weWEBURL: '//www.westelm.com.mx',
    truWEBURL: '//www.toysrus.com.mx',

    lpGRURL: '//mesaderegalos.liverpool.com.mx',
    wsGRURL: '//mesaderegalos.williams-sonoma.com.mx',
    pbGRURL: '//mesaderegalos.potterybarn.com.mx',
    pbkGRURL: '//mesaderegalos.potterybarnkids.com.mx',
    gapGRURL: '//mesaderegalos.gap.com.mx',
    wlmGRURL: '//mesaderegalos.westelm.com.mx',
    truGRURL: '//mesaderegalos.toysrus.com.mx',

    lpEventWebSiteURL: '//api.mesaderegalos.liverpool.mx/liverpool/auth', // check valid url

    lpURLPriFix: '/tienda',
    KalturaAPIURL: 'https://www.kaltura.com/api_v3',
    KalturaPartnerID: '2374251',
    KalturaSecretKey: '2ccc6cbf495a16639365cd6edda99b33',
    KalturaUser: 'htrejos@liverpool.com.mx', // fapalaciosp@liverpool.com.mx

    yahooUserURL: '/v1/user/',
    YahooAuthAPIURL: 'https://api.login.yahoo.com',
    YahooSocialAPI: 'https://social.yahooapis.com',

    YahooClientId:
      'dj0yJmk9TDlOeDBLemFGdGFvJmQ9WVdrOU5VSnlOMEp0TkRJbWNHbzlNQS0tJnM9Y29uc3VtZXJzZWNyZXQmeD0xYg--',
    YahooClientSecret: 'f0ca5694af2088da6369351704264d68228992a3',
    YahooRedirectURI:
      'https://mesaderegalos.liverpool.com.mx/auth/yahoo/callback',

    YahooClientIdPB:
      'dj0yJmk9M2drbTRleUFrYXFjJmQ9WVdrOWFXbDNWSGx5TnpRbWNHbzlNQS0tJnM9Y29uc3VtZXJzZWNyZXQmeD0yMw--',
    YahooClientSecretPB: 'd013c0dff8a83994d21f16d1915325f714174eb8',
    YahooRedirectURIPB:
      'https://mesaderegalos.potterybarn.com.mx/auth/yahoo/callback',

    YahooClientIdGAP:
      'dj0yJmk9YW5MVGdLR3hORjUzJmQ9WVdrOVVEWk5RVk5JTXpBbWNHbzlNQS0tJnM9Y29uc3VtZXJzZWNyZXQmeD0xYQ--',
    YahooClientSecretGAP: '37a257b590428fabe4cf79fb37df342072216a7c',
    YahooRedirectURIGAP: 'https://mesaderegalos.gap.com.mx/auth/yahoo/callback',

    YahooClientIdWLM:
      'dj0yJmk9dXRETlZYa1BUWXRSJmQ9WVdrOVJYSnVSM296TjJVbWNHbzlNQS0tJnM9Y29uc3VtZXJzZWNyZXQmeD1mMQ--',
    YahooClientSecretWLM: '0758edf06709e61e4a0426516cdaa5cf7aa1d560',
    YahooRedirectURIWLM:
      'https://mesaderegalos.westelm.com.mx/auth/yahoo/callback',

    YahooClientIdWS:
      'dj0yJmk9YTlYSmhHVlVGakJRJmQ9WVdrOU5Va3pjR0ZKTkc4bWNHbzlNQS0tJnM9Y29uc3VtZXJzZWNyZXQmeD02NQ--',
    YahooClientSecretWS: '7871c73f7c9fc09f9b98620ff358d178ae27d9e6',
    YahooRedirectURIWS:
      'https://mesaderegalos.williams-sonoma.com.mx/auth/yahoo/callback',

    YahooClientIdPBK:
      'dj0yJmk9V21NTkxaWUdoMHNVJmQ9WVdrOWJWWTFUelZPTldFbWNHbzlNQS0tJnM9Y29uc3VtZXJzZWNyZXQmeD1kNQ--',
    YahooClientSecretPBK: 'ce31b5c075231cbd283d8209e03c168571688155',
    YahooRedirectURIPBK:
      'https://mesaderegalos.potterybarnkids.com.mx/auth/yahoo/callback',

    YahooClientIdTRU: '',
    YahooClientSecretTRU: '',
    YahooRedirectURITRU: '',

    gmailClientKey:
      '332902283221-1iciqttl1355dts33vgmvf32cqo5e9tu.apps.googleusercontent.com', // creatr with LPmx
    gmailApikey: 'AIzaSyC8G-pT_64JDcgcErf2CiDcyKy9Sr4CGl4',

    /* Google Map API Keys provided by Client */
    googleMapApiKeyLP: 'AIzaSyAfZ6yVQdG4ePMI8N-xW1vkh3KTwaZ5SRk',
    googleMapApiKeyPB: 'AIzaSyCGqNf-wWAjOx9nQm7DZ2nR_kltiphDIZ4',
    googleMapApiKeyWS: 'AIzaSyCGqNf-wWAjOx9nQm7DZ2nR_kltiphDIZ4',
    googleMapApiKeyWLM: 'AIzaSyCGqNf-wWAjOx9nQm7DZ2nR_kltiphDIZ4',
    googleMapApiKeyGAP: 'AIzaSyCGqNf-wWAjOx9nQm7DZ2nR_kltiphDIZ4',
    googleMapApiKeyPBK: 'AIzaSyCGqNf-wWAjOx9nQm7DZ2nR_kltiphDIZ4',
    googleMapApiKeyTRU: 'AIzaSyCGqNf-wWAjOx9nQm7DZ2nR_kltiphDIZ4',

    isLocalAsset: false,
    excelTemplate: '/web/guestList/GR_guest_list-template.xls ',

    lpGROulookId: '1f2070c5-ef0d-4fee-97d3-34f4910255ae',
    pbGROulookId: '358d4765-8758-4839-940a-e23bedbfae78',
    wsGROulookId: 'd646f862-f035-4ebc-98c0-3eaf24bf18c4',
    gapGROulookId: '2ee487a8-bb6e-4a69-bd31-763c95d33efb',
    pbkGROulookId: '18aee1b7-e47b-44eb-add3-2a861e399fc5',
    wlmROulookId: '257cdf7b-1d6b-4e2a-99e9-6ec51425f94a',
    truGROulookId: '',

    lpGROulookRedirectUri: 'https://mesaderegalos.liverpool.com.mx/outlook',
    wsGROulookRedirectUri:
      'https://mesaderegalos.williams-sonoma.com.mx/outlook',
    pbGROulookRedirectUri: 'https://mesaderegalos.potterybarn.com.mx/outlook',
    pbkGROulookRedirectUri:
      'https://mesaderegalos.potterybarnkids.com.mx/outlook',
    gapGROulookRedirectUri: 'https://mesaderegalos.gap.com.mx/outlook',
    wlmGROulookRedirectUriL: 'https://mesaderegalos.westelm.com.mx/outlook',
    truGROulookRedirectUri: 'https://mesaderegalos.toysrus.com.mx/outlook',

    lpfacebookAppId: '1011947348978643', // liverpool.demoapis@gmail.com
    wsfacebookAppId: '1011947348978643',
    pbfacebookAppId: '1011947348978643',
    pbkfacebookAppId: '1011947348978643',
    gapfacebookAppId: '1011947348978643',
    wlmfacebookAppId: '1011947348978643',
    trufacebookAppId: '1011947348978643',

    lpTagging: {
      GTMID: 'GTM-5S3SR6Q',
      Auth: 'RtJDaFbRFM94IF5mTf4DNA',
      previewID: 'env-2',
    },
    wsTagging: {
      GTMID: 'GTM-5S3SR6Q',
      Auth: 'RtJDaFbRFM94IF5mTf4DNA',
      previewID: 'env-2',
    },
    pbTagging: {
      GTMID: 'GTM-5S3SR6Q',
      Auth: 'RtJDaFbRFM94IF5mTf4DNA',
      previewID: 'env-2',
    },
    pbkTagging: {
      GTMID: 'GTM-5S3SR6Q',
      Auth: 'RtJDaFbRFM94IF5mTf4DNA',
      previewID: 'env-2',
    },
    gapTagging: {
      GTMID: 'GTM-5S3SR6Q',
      Auth: 'RtJDaFbRFM94IF5mTf4DNA',
      previewID: 'env-2',
    },
    wlmTagging: {
      GTMID: 'GTM-5S3SR6Q',
      Auth: 'RtJDaFbRFM94IF5mTf4DNA',
      previewID: 'env-2',
    },
    truTagging: {
      GTMID: 'GTM-5S3SR6Q',
      Auth: 'RtJDaFbRFM94IF5mTf4DNA',
      previewID: 'env-2',
    },

    // wsTagging: {
  },
  sit1: {
    /* LP & Multisite UAT assets URLs */
    lpAssectURL: '/assets',
    pbAssectURL: '/assets',
    wsAssectURL: '/assets',
    pbkAssectURL: '/assets',
    gapAssectURL: '/assets',
    weAssectURL: '/assets',
    truAssectURL: '/assets',

    /* LP & Multisite UAT redirect URLs */
    lpWEBURL: '//ogcp-cms-sit.liverpool.com.mx',
    pbWEBURL: '//ogcp-cms-sit.potterybarn.com.mx',
    wsWEBURL: '//ogcp-cms-sit.williams-sonoma.com.mx',
    gapWEBURL: '//ogcp-cms-sit.gap.com.mx',
    pbkWEBURL: '//ogcp-cms-sit.potterybarnkids.com.mx',
    weWEBURL: '//ogcp-cms-sit.westelm.com.mx',
    truWEBURL: '//ogcp-cms-sit.toysrus.com.mx',

    /* LP & Multisite UAT GR URLs */
    lpGRURL: '//mesaderegalosqa2.liverpool.com.mx',
    wsGRURL: '//mrdtaqa.williams-sonoma.com.mx',
    pbGRURL: '//mrdtaqa.potterybarn.com.mx',
    pbkGRURL: '//mrdtaqa.potterybarnkids.com.mx',
    gapGRURL: '//mesaderegalosqa2.gap.com.mx',
    wlmGRURL: '//mrdtaqa.westelm.com.mx',
    truGRURL: '//mesaderegalosdtaqa.toysrus.com.mx',

    /* Multisite SIT Login redirect URLs */
    pbLoginURL: '//dtaqa.potterybarn.com.mx',
    wsLoginURL: '//dtaqa.williams-sonoma.com.mx',
    gapLoginURL: '//dtaqa.gap.com.mx',
    pbkLoginURL: '//dtaqa.potterybarnkids.com.mx',
    weLoginURL: '//dtaqa.westelm.com.mx',
    truLoginURL: '//dtaqa.toysrus.com.mx',

    lpEventWebSiteURL: '//uat-api.mesaderegalos.liverpool.mx/liverpool/auth', // check valid url

    lpURLPriFix: '/tienda',
    KalturaAPIURL: 'https://www.kaltura.com/api_v3',

    KalturaPartnerID: '2374251',
    KalturaSecretKey: '2ccc6cbf495a16639365cd6edda99b33',
    KalturaUser: 'fapalaciosp@liverpool.com.mx',

    gmailClientKey:
      '332902283221-1iciqttl1355dts33vgmvf32cqo5e9tu.apps.googleusercontent.com', // creatr with LPmx
    gmailApikey: 'AIzaSyC8G-pT_64JDcgcErf2CiDcyKy9Sr4CGl4',

    /* Google Map API Keys */
    googleMapApiKeyLP: 'AIzaSyAfZ6yVQdG4ePMI8N-xW1vkh3KTwaZ5SRk',
    googleMapApiKeyPB: 'AIzaSyCGqNf-wWAjOx9nQm7DZ2nR_kltiphDIZ4',
    googleMapApiKeyWS: 'AIzaSyCGqNf-wWAjOx9nQm7DZ2nR_kltiphDIZ4',
    googleMapApiKeyWLM: 'AIzaSyCGqNf-wWAjOx9nQm7DZ2nR_kltiphDIZ4',
    googleMapApiKeyGAP: 'AIzaSyCGqNf-wWAjOx9nQm7DZ2nR_kltiphDIZ4',
    googleMapApiKeyPBK: 'AIzaSyCGqNf-wWAjOx9nQm7DZ2nR_kltiphDIZ4',
    googleMapApiKeyTRU: 'AIzaSyCGqNf-wWAjOx9nQm7DZ2nR_kltiphDIZ4',

    isLocalAsset: false,
    excelTemplate: '/web/guestList/GR_guest_list-template.xls ',

    lpGROulookId: '1f2070c5-ef0d-4fee-97d3-34f4910255ae',
    pbGROulookId: '358d4765-8758-4839-940a-e23bedbfae78',
    wsGROulookId: 'd646f862-f035-4ebc-98c0-3eaf24bf18c4',
    gapGROulookId: '2ee487a8-bb6e-4a69-bd31-763c95d33efb',
    pbkGROulookId: '18aee1b7-e47b-44eb-add3-2a861e399fc5',
    wlmROulookId: '257cdf7b-1d6b-4e2a-99e9-6ec51425f94a',
    truGROulookId: '',

    lpGROulookRedirectUri: 'https://mesaderegalosqa.liverpool.com.mx/outlook',
    wsGROulookRedirectUri:
      'https://mesaderegalosqa.williams-sonoma.com.mx/outlook',
    pbGROulookRedirectUri: 'https://mesaderegalosqa.potterybarn.com.mx/outlook',
    pbkGROulookRedirectUri:
      'https://mesaderegalosqa.potterybarnkids.com.mx/outlook',
    gapGROulookRedirectUri: 'https://mesaderegalosqa.gap.com.mx/outlook',
    wlmGROulookRedirectUriL: 'https://mesaderegalosqa.westelm.com.mx/outlook',
    truGROulookRedirectUri: 'https://mesaderegalosqa.toysrus.com.mx/outlook',

    lpfacebookAppId: '2338494446209650', // liverpool.demoapis@gmail.com
    wsfacebookAppId: '2338494446209650',
    pbfacebookAppId: '2338494446209650',
    pbkfacebookAppId: '2338494446209650',
    gapfacebookAppId: '2338494446209650',
    wlmfacebookAppId: '2338494446209650',
    trufacebookAppId: '2338494446209650',

    yahooUserURL: '/v1/user/',
    YahooAuthAPIURL: 'https://api.login.yahoo.com',
    YahooSocialAPI: 'https://social.yahooapis.com',

    YahooClientId:
      'dj0yJmk9S2VaTWJWWEVDb2RBJmQ9WVdrOU9GVjFWelV5TldjbWNHbzlNQS0tJnM9Y29uc3VtZXJzZWNyZXQmeD1mYg--',
    YahooClientSecret: '99431fccc3e0f39018847adda4ce0521c837d31a',
    YahooRedirectURI:
      'https://mesaderegalosst.liverpool.com.mx/auth/yahoo/callback',

    YahooClientIdPB:
      'dj0yJmk9M0pUQ3J6ODc1OHBUJmQ9WVdrOWIwa3dhMmhTTkc4bWNHbzlNQS0tJnM9Y29uc3VtZXJzZWNyZXQmeD03MA--',
    YahooClientSecretPB: '6de0370a47b2c1ce43c7595bbc2f090e26acc5af',
    YahooRedirectURIPB:
      'https://mesaderegalosst.potterybarn.com.mx/auth/yahoo/callback',

    YahooClientIdGAP:
      'dj0yJmk9c1ZlQWNyMDZldk56JmQ9WVdrOVFteHlaalp2TjJFbWNHbzlNQS0tJnM9Y29uc3VtZXJzZWNyZXQmeD0xOQ--',
    YahooClientSecretGAP: '955571c81402b0c7206531dc50aa471543d31a5a',
    YahooRedirectURIGAP:
      'https://mesaderegalosst.gap.com.mx/auth/yahoo/callback',

    YahooClientIdWLM:
      'dj0yJmk9U29JMEpGV3NuekJKJmQ9WVdrOVVETTNXSE5oTjJjbWNHbzlNQS0tJnM9Y29uc3VtZXJzZWNyZXQmeD02ZQ--',
    YahooClientSecretWLM: 'c286762ed8190e187358bc2c6ca11341ba556172',
    YahooRedirectURIWLM:
      'https://mesaderegalosst.westelm.com.mx/auth/yahoo/callback',

    YahooClientIdWS:
      'dj0yJmk9V0dRTVh6TkNrd2p0JmQ9WVdrOVdqRkRVWGsxTjJzbWNHbzlNQS0tJnM9Y29uc3VtZXJzZWNyZXQmeD1jMg--',
    YahooClientSecretWS: '3ae2a541d08b48dc3e611d098a26ca628cffc9df',
    YahooRedirectURIWS:
      'https://mesaderegalosst.williams-sonoma.com.mx/auth/yahoo/callback',

    YahooClientIdPBK:
      'dj0yJmk9bnhyaThhYmR4bDZLJmQ9WVdrOWVuVm5Na2xDTXpZbWNHbzlNQS0tJnM9Y29uc3VtZXJzZWNyZXQmeD1jNw--',
    YahooClientSecretPBK: '0e3d8d952050400e34b1c263ec13e6d178c2eaf4',
    YahooRedirectURIPBK:
      'https://mesaderegalosst.potterybarnkids.com.mx/auth/yahoo/callback',

    YahooClientIdTRU: '',
    YahooClientSecretTRU: '',
    YahooRedirectURITRU: '',

    lpTagging: {
      GTMID: 'GTM-WJPZC4D',
      Auth: 'Bj15C7rwI_jc3R9WhAeESg',
      previewID: 'env-31',
    },

    wsTagging: {
      GTMID: 'GTM-WJPZC4D',
      Auth: 'Bj15C7rwI_jc3R9WhAeESg',
      previewID: 'env-31',
    },
    pbTagging: {
      GTMID: 'GTM-WJPZC4D',
      Auth: 'Bj15C7rwI_jc3R9WhAeESg',
      previewID: 'env-31',
    },
    pbkTagging: {
      GTMID: 'GTM-WJPZC4D',
      Auth: 'Bj15C7rwI_jc3R9WhAeESg',
      previewID: 'env-31',
    },
    gapTagging: {
      GTMID: 'GTM-WJPZC4D',
      Auth: 'Bj15C7rwI_jc3R9WhAeESg',
      previewID: 'env-31',
    },
    wlmTagging: {
      GTMID: 'GTM-WJPZC4D',
      Auth: 'Bj15C7rwI_jc3R9WhAeESg',
      previewID: 'env-31',
    },
    truTagging: {
      GTMID: 'GTM-WJPZC4D',
      Auth: 'Bj15C7rwI_jc3R9WhAeESg',
      previewID: 'env-31',
    },
  },
  qa1: {
    /* LP & Multisite UAT assets URLs */
    lpAssectURL: '/assets',
    pbAssectURL: '/assets',
    wsAssectURL: '/assets',
    pbkAssectURL: '/assets',
    gapAssectURL: '/assets',
    weAssectURL: '/assets',
    truAssectURL: '/assets',

    /* LP & Multisite UAT redirect URLs */
    lpWEBURL: '//dtaqa.liverpool.com.mx',
    pbWEBURL: '//dtaqa.potterybarn.com.mx',
    wsWEBURL: '//dtaqa.williams-sonoma.com.mx',
    gapWEBURL: '//dtaqa.gap.com.mx',
    pbkWEBURL: '//dtaqa.potterybarnkids.com.mx',
    weWEBURL: '//dtaqa.westelm.com.mx',
    truWEBURL: '//dtaqa.toysrus.com.mx',

    /* LP & Multisite UAT GR URLs */
    lpGRURL: '//ogcp-gr-qa1.liverpool.com.mx',
    wsGRURL: '//ogcp-gr-qa1.williams-sonoma.com.mx',
    pbGRURL: '//ogcp-gr-qa1.potterybarn.com.mx',
    pbkGRURL: '//ogcp-gr-qa1.potterybarnkids.com.mx',
    gapGRURL: '//ogcp-gr-qa1.gap.com.mx',
    wlmGRURL: '//ogcp-gr-qa1.westelm.com.mx',
    truGRURL: '//ogcp-gr-qa1.toysrus.com.mx',

    /* Multisite SIT Login redirect URLs */
    pbLoginURL: '//dtaqa.potterybarn.com.mx',
    wsLoginURL: '//dtaqa.williams-sonoma.com.mx',
    gapLoginURL: '//dtaqa.gap.com.mx',
    pbkLoginURL: '//dtaqa.potterybarnkids.com.mx',
    weLoginURL: '//dtaqa.westelm.com.mx',
    truLoginURL: '//dtaqa.toysrus.com.mx',

    lpEventWebSiteURL: '//uat-api.mesaderegalos.liverpool.mx/liverpool/auth', // check valid url

    lpURLPriFix: '/tienda',
    KalturaAPIURL: 'https://www.kaltura.com/api_v3',

    KalturaPartnerID: '2374251',
    KalturaSecretKey: '2ccc6cbf495a16639365cd6edda99b33',
    KalturaUser: 'fapalaciosp@liverpool.com.mx',

    gmailClientKey:
      '332902283221-1iciqttl1355dts33vgmvf32cqo5e9tu.apps.googleusercontent.com', // creatr with LPmx
    gmailApikey: 'AIzaSyC8G-pT_64JDcgcErf2CiDcyKy9Sr4CGl4',

    /* Google Map API Keys */
    googleMapApiKeyLP: 'AIzaSyAfZ6yVQdG4ePMI8N-xW1vkh3KTwaZ5SRk',
    googleMapApiKeyPB: 'AIzaSyCGqNf-wWAjOx9nQm7DZ2nR_kltiphDIZ4',
    googleMapApiKeyWS: 'AIzaSyCGqNf-wWAjOx9nQm7DZ2nR_kltiphDIZ4',
    googleMapApiKeyWLM: 'AIzaSyCGqNf-wWAjOx9nQm7DZ2nR_kltiphDIZ4',
    googleMapApiKeyGAP: 'AIzaSyCGqNf-wWAjOx9nQm7DZ2nR_kltiphDIZ4',
    googleMapApiKeyPBK: 'AIzaSyCGqNf-wWAjOx9nQm7DZ2nR_kltiphDIZ4',
    googleMapApiKeyTRU: 'AIzaSyCGqNf-wWAjOx9nQm7DZ2nR_kltiphDIZ4',

    isLocalAsset: false,
    excelTemplate: '/web/guestList/GR_guest_list-template.xls ',

    lpGROulookId: '1f2070c5-ef0d-4fee-97d3-34f4910255ae',
    pbGROulookId: '358d4765-8758-4839-940a-e23bedbfae78',
    wsGROulookId: 'd646f862-f035-4ebc-98c0-3eaf24bf18c4',
    gapGROulookId: '2ee487a8-bb6e-4a69-bd31-763c95d33efb',
    pbkGROulookId: '18aee1b7-e47b-44eb-add3-2a861e399fc5',
    wlmROulookId: '257cdf7b-1d6b-4e2a-99e9-6ec51425f94a',
    truGROulookId: '',

    lpGROulookRedirectUri: 'https://mesaderegalosqa.liverpool.com.mx/outlook',
    wsGROulookRedirectUri:
      'https://mesaderegalosqa.williams-sonoma.com.mx/outlook',
    pbGROulookRedirectUri: 'https://mesaderegalosqa.potterybarn.com.mx/outlook',
    pbkGROulookRedirectUri:
      'https://mesaderegalosqa.potterybarnkids.com.mx/outlook',
    gapGROulookRedirectUri: 'https://mesaderegalosqa.gap.com.mx/outlook',
    wlmGROulookRedirectUriL: 'https://mesaderegalosqa.westelm.com.mx/outlook',
    truGROulookRedirectUri: 'https://mesaderegalosqa.toysrus.com.mx/outlook',

    lpfacebookAppId: '2338494446209650', // liverpool.demoapis@gmail.com
    wsfacebookAppId: '2338494446209650',
    pbfacebookAppId: '2338494446209650',
    pbkfacebookAppId: '2338494446209650',
    gapfacebookAppId: '2338494446209650',
    wlmfacebookAppId: '2338494446209650',
    trufacebookAppId: '2338494446209650',

    yahooUserURL: '/v1/user/',
    YahooAuthAPIURL: 'https://api.login.yahoo.com',
    YahooSocialAPI: 'https://social.yahooapis.com',

    YahooClientId:
      'dj0yJmk9S2VaTWJWWEVDb2RBJmQ9WVdrOU9GVjFWelV5TldjbWNHbzlNQS0tJnM9Y29uc3VtZXJzZWNyZXQmeD1mYg--',
    YahooClientSecret: '99431fccc3e0f39018847adda4ce0521c837d31a',
    YahooRedirectURI:
      'https://mesaderegalosst.liverpool.com.mx/auth/yahoo/callback',

    YahooClientIdPB:
      'dj0yJmk9M0pUQ3J6ODc1OHBUJmQ9WVdrOWIwa3dhMmhTTkc4bWNHbzlNQS0tJnM9Y29uc3VtZXJzZWNyZXQmeD03MA--',
    YahooClientSecretPB: '6de0370a47b2c1ce43c7595bbc2f090e26acc5af',
    YahooRedirectURIPB:
      'https://mesaderegalosst.potterybarn.com.mx/auth/yahoo/callback',

    YahooClientIdGAP:
      'dj0yJmk9c1ZlQWNyMDZldk56JmQ9WVdrOVFteHlaalp2TjJFbWNHbzlNQS0tJnM9Y29uc3VtZXJzZWNyZXQmeD0xOQ--',
    YahooClientSecretGAP: '955571c81402b0c7206531dc50aa471543d31a5a',
    YahooRedirectURIGAP:
      'https://mesaderegalosst.gap.com.mx/auth/yahoo/callback',

    YahooClientIdWLM:
      'dj0yJmk9U29JMEpGV3NuekJKJmQ9WVdrOVVETTNXSE5oTjJjbWNHbzlNQS0tJnM9Y29uc3VtZXJzZWNyZXQmeD02ZQ--',
    YahooClientSecretWLM: 'c286762ed8190e187358bc2c6ca11341ba556172',
    YahooRedirectURIWLM:
      'https://mesaderegalosst.westelm.com.mx/auth/yahoo/callback',

    YahooClientIdWS:
      'dj0yJmk9V0dRTVh6TkNrd2p0JmQ9WVdrOVdqRkRVWGsxTjJzbWNHbzlNQS0tJnM9Y29uc3VtZXJzZWNyZXQmeD1jMg--',
    YahooClientSecretWS: '3ae2a541d08b48dc3e611d098a26ca628cffc9df',
    YahooRedirectURIWS:
      'https://mesaderegalosst.williams-sonoma.com.mx/auth/yahoo/callback',

    YahooClientIdPBK:
      'dj0yJmk9bnhyaThhYmR4bDZLJmQ9WVdrOWVuVm5Na2xDTXpZbWNHbzlNQS0tJnM9Y29uc3VtZXJzZWNyZXQmeD1jNw--',
    YahooClientSecretPBK: '0e3d8d952050400e34b1c263ec13e6d178c2eaf4',
    YahooRedirectURIPBK:
      'https://mesaderegalosst.potterybarnkids.com.mx/auth/yahoo/callback',

    YahooClientIdTRU: '',
    YahooClientSecretTRU: '',
    YahooRedirectURITRU: '',

    lpTagging: {
      GTMID: 'GTM-WJPZC4D',
      Auth: 'Bj15C7rwI_jc3R9WhAeESg',
      previewID: 'env-31',
    },

    wsTagging: {
      GTMID: 'GTM-WJPZC4D',
      Auth: 'Bj15C7rwI_jc3R9WhAeESg',
      previewID: 'env-31',
    },
    pbTagging: {
      GTMID: 'GTM-WJPZC4D',
      Auth: 'Bj15C7rwI_jc3R9WhAeESg',
      previewID: 'env-31',
    },
    pbkTagging: {
      GTMID: 'GTM-WJPZC4D',
      Auth: 'Bj15C7rwI_jc3R9WhAeESg',
      previewID: 'env-31',
    },
    gapTagging: {
      GTMID: 'GTM-WJPZC4D',
      Auth: 'Bj15C7rwI_jc3R9WhAeESg',
      previewID: 'env-31',
    },
    wlmTagging: {
      GTMID: 'GTM-WJPZC4D',
      Auth: 'Bj15C7rwI_jc3R9WhAeESg',
      previewID: 'env-31',
    },
    truTagging: {
      GTMID: 'GTM-WJPZC4D',
      Auth: 'Bj15C7rwI_jc3R9WhAeESg',
      previewID: 'env-31',
    },
  },
};
